import { useMemo } from "react";
import { RpServiceTemplate } from "@idw-types/data/reference-data/generic";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { resources } from "@constants/hardcoded-strings";

type RelyingPartyServiceTemplateSelectFormGroupProps = BaseSelectFormGroupProps & {
    templates: Array<RpServiceTemplate>
};

export const RelyingPartyServiceTemplateSelectFormGroup = (props: RelyingPartyServiceTemplateSelectFormGroupProps) => {
    const { templates, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const templateOptions = useMemo(() => {
        return mapEntitiesWithNameAndIdToSelectOptions(templates);
    }, [templates]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-rp-service-template-select`}
            label={resources.common.inputs.template.label}
            ariaLabel={resources.common.inputs.template.label}
            automationId={`${idPrefix}-rp-service-template-select`}
            onChange={onChange}
            options={templateOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};